import { render, staticRenderFns } from "./InventarioSimPantalla.vue?vue&type=template&id=15525718&"
import script from "./InventarioSimPantalla.vue?vue&type=script&lang=ts&"
export * from "./InventarioSimPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('15525718', component.options)
    } else {
      api.reload('15525718', component.options)
    }
    module.hot.accept("./InventarioSimPantalla.vue?vue&type=template&id=15525718&", function () {
      api.rerender('15525718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/InventarioSim/InventarioSimPantalla.vue"
export default component.exports